import {useMemo} from 'react';

import type {WidgetFragment} from 'nutshell-graphql-types';

import {EmailSequencesWidget} from '../../../../core-entity/widgets/email-sequences-widget/email-sequences-widget';
import {filterExemptedAutomationStatuses} from '../../../../core-entity/widgets/email-sequences-widget/helpers';
import type {PostMutationCallbacks} from '../../../../core-entity/widgets/email-sequences-widget/types';

import {contactRefetchForEvent} from '../../hooks/use-contact-update-refetch';

import {useGetContactEmailSequenceData} from './graphql/hooks/use-get-contact-email-sequence-data';

interface Props {
    contactId: string;
    widget: WidgetFragment;
}

const postMutationCallbacks: PostMutationCallbacks = {
    cancelDrip: () => contactRefetchForEvent('dripSequenceCancel'),
    cancelManual: () => contactRefetchForEvent('manuallyStartedPersonalEmailSequenceCancel'),
    cancelPersonal: () => contactRefetchForEvent('personalEmailSequenceCancel'),
    startPersonal: () => contactRefetchForEvent('personalEmailSequenceStart'),
    sendNow: () => contactRefetchForEvent('personalEmailSequenceSendNow'),
};

export function ContactEmailSequencesWidget(props: Props) {
    const {contactName, dripProgressions, emailAutomationStatuses, queuedEmails, isFirstLoading} =
        useGetContactEmailSequenceData(props.contactId);

    const contactWithDripProgressions = useMemo(() => {
        if (!dripProgressions) return [];

        return [
            {
                id: props.contactId,
                name: contactName ?? '',
                dripProgressions: dripProgressions,
            },
        ];
    }, [props.contactId, contactName, dripProgressions]);

    return (
        <EmailSequencesWidget
            widget={props.widget}
            contactsWithDripProgressions={contactWithDripProgressions}
            emailAutomationStatuses={filterExemptedAutomationStatuses(
                emailAutomationStatuses ?? []
            )}
            queuedEmails={queuedEmails}
            isFirstLoadingDripSequences={isFirstLoading}
            isFirstLoadingEmailAutomationStatuses={isFirstLoading}
            isFirstLoadingManuallyStartedSequences={isFirstLoading}
            postMutationCallbacks={postMutationCallbacks}
        />
    );
}
